import { useRef, useEffect } from 'react';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const learnMoreLists: Record<string, string[]> = {
    eu: [
        'https://eu.ecoflow.com/products/250w-rigid-solar-panel',
        'https://eu.ecoflow.com/products/400w-rigid-solar-panel',
        'https://eu.ecoflow.com/products/450w-rigid-solar-panel',
        'https://eu.ecoflow.com/products/520w-rigid-solar-panel',
    ],
    uk: [
        'https://uk.ecoflow.com/products/250w-rigid-solar-panel',
        'https://uk.ecoflow.com/products/400w-rigid-solar-panel',
        'https://uk.ecoflow.com/products/450w-rigid-solar-panel',
        'https://uk.ecoflow.com/products/520w-rigid-solar-panel',
    ],
    es: [
        'https://es.ecoflow.com/products/250w-rigid-solar-panel',
        'https://es.ecoflow.com/products/400w-rigid-solar-panel',
        'https://es.ecoflow.com/products/450w-rigid-solar-panel',
        'https://es.ecoflow.com/products/520w-rigid-solar-panel',
    ],
    it: [
        'https://it.ecoflow.com/products/250w-rigid-solar-panel',
        'https://it.ecoflow.com/products/400w-rigid-solar-panel',
        'https://it.ecoflow.com/products/450w-rigid-solar-panel',
        'https://it.ecoflow.com/products/520w-rigid-solar-panel',
    ],
    de: [
        'https://de.ecoflow.com/products/250w-rigid-solar-panel',
        'https://de.ecoflow.com/products/400w-rigid-solar-panel',
        'https://de.ecoflow.com/products/450w-rigid-solar-panel',
        'https://de.ecoflow.com/products/520w-rigid-solar-panel',
    ],
    fr: [
        'https://fr.ecoflow.com/products/250w-rigid-solar-panel',
        'https://fr.ecoflow.com/products/400w-rigid-solar-panel',
        'https://fr.ecoflow.com/products/450w-rigid-solar-panel',
        'https://fr.ecoflow.com/products/520w-rigid-solar-panel',
    ],
};

export default function SectionCompare() {
    const { t } = useLang('theProduct.SectionCompare');
    const { locale } = getLocal();
    const refA = useRef(null);

    const text = learnMoreLists[locale] || learnMoreLists.eu;

    const itemsA = [
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748160820042/compare_1.png',
                    // label: t('product_label'),
                    label: t('new'),
                    title: t('product1_main_title'),
                    rChildren: t('learn_more'),
                    rHref: text[0],
                    specItems: [
                        {
                            title: t('product1_title1'),
                            desc: t('product1_desc1'),
                        },
                        {
                            title: t('product1_title2'),
                            desc: t('product1_desc2'),
                        },
                        {
                            title: t('product1_title3'),
                            desc: t('product1_desc3'),
                        },
                        {
                            title: t('product1_title4'),
                            desc: t('product1_desc4'),
                        },
                        {
                            title: t('product1_title5'),
                            desc: t('product1_desc5'),
                        },
                        {
                            title: t('product1_title6'),
                            desc: t('product1_desc6'),
                        },
                        {
                            title: t('product1_title7'),
                            desc: t('product1_desc7'),
                        },
                        {
                            title: t('product1_title8'),
                            desc: t('product1_desc8'),
                        },
                        {
                            title: t('product1_title9'),
                            desc: t('product1_desc9'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748160822593/compare_2.png',
                    title: t('product2_main_title'),
                    rChildren: t('learn_more'),
                    rHref: text[1],

                    specItems: [
                        {
                            title: t('product2_title1'),
                            desc: t('product2_desc1'),
                        },
                        {
                            title: t('product2_title2'),
                            desc: t('product2_desc2'),
                        },
                        {
                            title: t('product2_title3'),
                            desc: t('product2_desc3'),
                        },
                        {
                            title: t('product2_title4'),
                            desc: t('product2_desc4'),
                        },
                        {
                            title: t('product2_title5'),
                            desc: t('product2_desc5'),
                        },
                        {
                            title: t('product2_title6'),
                            desc: t('product2_desc6'),
                        },
                        {
                            title: t('product2_title7'),
                            desc: t('product2_desc7'),
                        },
                        {
                            title: t('product2_title8'),
                            desc: t('product2_desc8'),
                        },
                        {
                            title: t('product2_title9'),
                            desc: t('product2_desc9'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748160825031/compare_3.png',
                    title: t('product3_main_title'),
                    rChildren: t('learn_more'),
                    rHref: text[2],

                    specItems: [
                        {
                            title: t('product3_title1'),
                            desc: t('product3_desc1'),
                        },
                        {
                            title: t('product3_title2'),
                            desc: t('product3_desc2'),
                        },
                        {
                            title: t('product3_title3'),
                            desc: t('product3_desc3'),
                        },
                        {
                            title: t('product3_title4'),
                            desc: t('product3_desc4'),
                        },
                        {
                            title: t('product3_title5'),
                            desc: t('product3_desc5'),
                        },
                        {
                            title: t('product3_title6'),
                            desc: t('product3_desc6'),
                        },
                        {
                            title: t('product3_title7'),
                            desc: t('product3_desc7'),
                        },
                        {
                            title: t('product3_title8'),
                            desc: t('product3_desc8'),
                        },
                        {
                            title: t('product3_title9'),
                            desc: t('product3_desc9'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748160828428/compare_4.png',
                    title: t('product4_main_title'),
                    rChildren: t('learn_more'),
                    label: t('new'),
                    rHref: text[3],

                    specItems: [
                        {
                            title: t('product4_title1'),
                            desc: t('product4_desc1'),
                        },
                        {
                            title: t('product4_title2'),
                            desc: t('product4_desc2'),
                        },
                        {
                            title: t('product4_title3'),
                            desc: t('product4_desc3'),
                        },
                        {
                            title: t('product4_title4'),
                            desc: t('product4_desc4'),
                        },
                        {
                            title: t('product4_title5'),
                            desc: t('product4_desc5'),
                        },
                        {
                            title: t('product4_title6'),
                            desc: t('product4_desc6'),
                        },
                        {
                            title: t('product4_title7'),
                            desc: t('product4_desc7'),
                        },
                        {
                            title: t('product4_title8'),
                            desc: t('product4_desc8'),
                        },
                        {
                            title: t('product4_title9'),
                            desc: t('product4_desc9'),
                        },
                    ],
                },
            ],
        },
    ];

    useEffect(() => {
        const listDomsB = (refA.current as any).querySelectorAll('.eco-compare-product-sub-item-h');

        for (let i = 0; i < listDomsB.length; i++) {
            const elemA = listDomsB[i];
            elemA.style.minHeight = '0';
        }
    }, []);

    return (
        <div className={styles.SectionCompare}>
            <div ref={refA}>
                <EcoCompareProduct items={itemsA} />
            </div>
            <div className="bottom-annotation eco-section-common">{t('text')}</div>
        </div>
    );
}
